import { BREAKPOINTS } from '@libs/common-next';
import type { Image } from '../types';

// Create a hooks for images
/** @deprecated new breakpoints for screen sizes https://petsmart.atlassian.net/wiki/spaces/DPT1/pages/177963092/Browser+and+Devices+Coverage */
export const propsImagesItems = (image: Image, includeTablet = false) => {
    const { remoteDesktopImageUrl, remoteTabletImageUrl, remoteMobileImageUrl } = image || {};

    const mobileSrcSet = includeTablet
        ? remoteMobileImageUrl || remoteTabletImageUrl || remoteDesktopImageUrl
        : remoteMobileImageUrl || remoteDesktopImageUrl;

    // Build image items
    return [
        {
            media: `(min-width: ${BREAKPOINTS.sm2}px)`,
            srcSet: remoteDesktopImageUrl || '',
        },
        {
            media: `(max-width: ${BREAKPOINTS.sm2}px)`,
            srcSet: mobileSrcSet || '',
        },
    ];
};

export const propsImageItems = (image: Image, sm2 = false) => {
    const { remoteDesktopImageUrl, remoteTabletImageUrl, remoteMobileImageUrl } = image || {};

    return [
        {
            media: `(min-width: ${BREAKPOINTS.lg}px)`,
            srcSet: remoteDesktopImageUrl,
        },
        {
            media: `(min-width: ${BREAKPOINTS[sm2 ? 'sm2' : 'md']}px)`,
            srcSet: remoteTabletImageUrl || remoteDesktopImageUrl || '',
        },
        {
            media: `(max-width: ${BREAKPOINTS[sm2 ? 'sm2' : 'md'] - 1}px)`,
            srcSet: remoteMobileImageUrl || remoteTabletImageUrl || remoteDesktopImageUrl || '',
        },
    ];
};

export const getImageProps = (img: Image) => {
    const image = propsImageItems(img);

    return {
        items: image,
        imgSrc: image[0]?.srcSet,
        imgAlt: img.webAltText,
    };
};

const addQueryParam = (url: string, params: string) => {
    const base = url.split('?');
    const existingParams = base.slice(1);
    const joiner = existingParams?.length ? '&' : '';
    return [base[0], '?', ...existingParams, joiner, params].join('');
};

export const optimizeImage = (image: Image) => {
    const baseImagesURL = 'https://s7d2.scene7.com/is/image/PetSmart';

    let { remoteDesktopImageUrl, remoteMobileImageUrl } = image;

    if (remoteDesktopImageUrl?.includes(baseImagesURL)) {
        remoteDesktopImageUrl = addQueryParam(remoteDesktopImageUrl, 'fmt=webp&qlt=60');
    }

    if (remoteMobileImageUrl?.includes(baseImagesURL)) {
        remoteMobileImageUrl = addQueryParam(remoteMobileImageUrl, 'fmt=webp&qlt=40');
    }

    return { ...image, remoteDesktopImageUrl, remoteMobileImageUrl };
};
